import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AccountService } from '../../../services/account.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { environment } from '../../../../environments/environment';
import { SetNewPasswordRequest } from '../../../model/userModel';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-reset-password-request',
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatButton,
    MatCardModule,
    RouterLink,
    MatProgressSpinner,
  ],
  templateUrl: './reset-password-request.component.html',
  styleUrl: './reset-password-request.component.scss',
})
export class ResetPasswordRequestComponent implements OnInit {
  private fb = inject(FormBuilder);
  accountService = inject(AccountService);
  private router = inject(Router);
  private snackbar = inject(SnackbarService);
  private route = inject(ActivatedRoute);

  production = environment.production;
  height = 0;

  loginForm = this.fb.group({
    email: [''],
    newPasswordConfirm: [''],
  });

  ngOnInit(): void {
    this.accountService.user$.subscribe((user) => {
      if (user) {
        this.route.queryParams.subscribe((params) => {
          const returnUrl = params['returnUrl'] || '/hours';
          this.router.navigate([returnUrl]);
        });
      }
    });
  }

  onSubmit(): void {
    const email = this.loginForm.value.email ?? '';
    this.accountService.requestResetPassword(email);
  }
}
